// src/stockx/base/PolicyIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var PolicyIcon = ({ colorized, ...props }) => /* @__PURE__ */ jsxs(Icon, { viewBox: "0 0 50 50", ...props, children: [
  colorized && /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M39.1998 43.9H10.7998V9.29999H39.0998V43.9H39.1998ZM12.8998 41.8H37.1998V11.4H12.8998V41.8Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M32.4999 11.4H17.3999V15.9H32.4999V11.4Z", fill: "#D4D1C7" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24.9998 12.5C26.491 12.5 27.6998 11.2911 27.6998 9.79998C27.6998 8.30881 26.491 7.09998 24.9998 7.09998C23.5086 7.09998 22.2998 8.30881 22.2998 9.79998C22.2998 11.2911 23.5086 12.5 24.9998 12.5Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24.9998 13.6C22.9998 13.6 21.2998 11.9 21.2998 9.90001C21.2998 7.90001 22.9998 6.20001 24.9998 6.20001C26.9998 6.20001 28.6998 7.90001 28.6998 9.90001C28.6998 11.9 26.9998 13.6 24.9998 13.6ZM24.9998 8.10001C23.9998 8.10001 23.2998 8.90001 23.2998 9.80001C23.2998 10.8 24.0998 11.5 24.9998 11.5C25.8998 11.5 26.6998 10.7 26.6998 9.80001C26.6998 8.90001 25.9998 8.10001 24.9998 8.10001Z",
        fill: "#D4D1C7"
      }
    )
  ] }),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M33.7 21.1H23V23.1H33.7V21.1Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M33.7 27.8H23V29.8H33.7V27.8Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M33.7 34.5H23V36.5H33.7V34.5Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M20.1 20.3H16.5V23.9H20.1V20.3Z",
      fill: colorized ? "#006340" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M20.1 27H16.5V30.6H20.1V27Z",
      fill: colorized ? "#006340" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M20.1 33.8H16.5V37.4H20.1V33.8Z",
      fill: colorized ? "#006340" : "currentColor"
    }
  ),
  !colorized && /* @__PURE__ */ jsx(
    "path",
    {
      d: "M28.6998 9.29998C28.4998 7.49998 26.8998 6.09998 24.9998 6.09998C23.0998 6.09998 21.5998 7.49998 21.2998 9.29998H10.7998V43.8H39.0998V9.29998H28.6998ZM24.9998 8.09998C25.9998 8.09998 26.6998 8.89998 26.6998 9.79998C26.6998 10.8 25.8998 11.5 24.9998 11.5C24.0998 11.5 23.2998 10.7 23.2998 9.79998C23.2998 8.89998 23.9998 8.09998 24.9998 8.09998ZM37.0998 41.8H12.8998V11.4H17.4998V15.9H32.5998V11.4H37.1998V41.8H37.0998Z",
      fill: "black"
    }
  )
] });
var PolicyIcon_default = PolicyIcon;

export {
  PolicyIcon_default
};
